// @flow
import * as React from "react";
import { images } from '../../config';
import {GradientBackdropContainer} from "./GradientBackdropStyle";

type OwnProps = {|
    children: React.Node,
|}

const GradientBackdropWithVan = (props: OwnProps) => {
    return (
        <GradientBackdropContainer>
            {props.children}
            <img src={images.thank_you_screen_image} alt={"van_image"}/>

        </GradientBackdropContainer>
    );

};
export default GradientBackdropWithVan;



// WEBPACK FOOTER //
// ./src/Components/GradientBackdrop/GradientBackdropWithVan.js